export default __webpack_public_path__ + "static/yoga-7-fcca1fd3cfab318978f32e97418cd7d8.png";